export const shortenDate = (date?: string | null) => {
    return date ? date.replace(/\..*/, '')  : ''
}